// Selector functions are part of Saga, which are used in Saga functions to access
// the selected state.

// Selectors for pdApi state
export const pdApiSelectors = {
  pdApi: (state: State.Root): State.PdApi => state.pdApi
};
export const ioConfigSelectors = {
  ioConfig: (state: State.Root): State.IoConfig => state.ioConfig
};

export const editViewSelectors = {
  editedObject: (state: State.Root): typeof state => state.editView.editedObject,
  storedObject: (state: State.Root): typeof state => state.editView.storedObject,
  parentObject: (state: State.Root): typeof state => state.editView.parentObject
};

export const mainSelector = {
  activeUser: (state: State.Root): Api.User | undefined => state.main.activeUser
};
